import { ApiError } from "@/lib/api";

// One place to turn an unknown caught value into a user-facing message: a handled
// ApiError carries the PMS message verbatim; anything else gets a safe fallback
// (CLAUDE.md #7 — failures surface as handled UI states, never a white-screen).
export function messageFor(err: unknown): string {
  if (err instanceof ApiError) return err.message;
  return "Something went wrong. Please try again.";
}
